import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import { Panel } from 'react-bootstrap';
import Switch from 'react-bootstrap-switch';
import { Link } from 'react-router-dom'

import Modal from '../../common/components/Modal';

import EmbedStringGenerator from '../lib/EmbedStringGenerator';
import RestrictedComponent from '../../lib/components/form/RestrictedComponent';
import schema from '../../routes/permissions/schema';

const noop = function () {};

var Preference = createReactClass({

    getInitialState: function () {
        return {
            mode: "script",
            deleteModal: false,
            previewAssignModal: false
        };
    },

    toggleDeleteModal: function (ev) {
        ev && ev.preventDefault();
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    },

    togglePreviewAssignModal: function (ev) {
        ev && ev.preventDefault();
        this.setState({
            previewAssignModal: !this.state.previewAssignModal
        });
    },

    handlePreviewAssignConfirm: function (ev) {
        ev && ev.preventDefault();
        this.setState({ previewAssignModal: false });
        this.props.handlePreferenceAssign();
    },

    handleDelete: function (ev) {
        ev && ev.preventDefault();
        this.props.actions.delete({
            prefID: this.props.preferenceID
        });
    },

    handleAssignDefault: function (ev) {
        ev && ev.preventDefault();

        var { preferenceID, actions } = this.props;

        actions.setPreferenceAsDefault({
            prefID: preferenceID,
            default: true
        });
    },

    render: function () {
        var { handleEdit, toggleDeleteModal, renderHeader, renderDeleteModal, renderPreviewAssignModal } = this;
        var { isDefault, event, preferenceID, mode } = this.props;
        var isAssignedToCurrentEvent = (
            mode == 'event' &&
            event.playerPref &&
            event.playerPref.playerPrefID == preferenceID
        );

        return (
            <div className="preference">
                <Panel className={
                        (isDefault ? ' default-preference ' : '') +
                        (isAssignedToCurrentEvent ? ' assigned-preference ' : '')}>
                    <Panel.Heading>
                        {renderHeader()}
                    </Panel.Heading>
                </Panel>
                {renderDeleteModal()}
                {renderPreviewAssignModal()}
            </div>
        );
    },

    isPreviewPref: function () {
        return Boolean(
            process.env.IS_PREVIEW_BUILD &&
            this.props.preference &&
            !this.props.preference.version
        );
    },

    renderHeader: function () {
        return (<div className="clearfix">
            <div className="col-md-6">
                <h4>{this.props.preference.name}
                    {(this.props.isDefault ?
                        <small style={{padding: '.5rem'}}>(Default Preference)</small> :
                        null)}
                    {(this.isPreviewPref() ?
                        <span className="label label-warning" style={{marginLeft: '.5rem', fontSize: '60%', verticalAlign: 'middle'}}
                            title="Preview format. Cannot be set as default. Only past-dated events allow assignment, and assignment will impact archive viewers. To preview risk-free, copy an event's player URL from its share tab and append &id=<this prefID>.">
                            PREVIEW
                        </span> :
                        null)}
                </h4>
            </div>
            <div className="col-md-6 toggle">
                {this.renderActions()}
            </div>
        </div>);
    },

    renderActions: function () {
        var { isDefault, preferenceID, /* preference, */ event, mode, eventIsPast } =
            this.props;

        if (mode && mode == 'event') {
            var assignedPreference = event.playerPref;
            if (assignedPreference != preferenceID) {
                var disabled = (event.playerPref && event.playerPref.playerPrefID == preferenceID);

                if (this.isPreviewPref()) {
                    if (!eventIsPast) {
                        return null;
                    }
                    return (<RestrictedComponent permissionCheck={schema.EVENT_TAB_PLAYER.UPDATE}>
                        <button
                            className="btn btn-warning"
                            onClick={this.togglePreviewAssignModal}
                            title="This pref uses a preview format. Assignment is only available for past-dated events and will impact archive viewers.">
                            <i className="fa fa-exclamation-triangle"/> Assign (Preview)
                        </button>
                    </RestrictedComponent>);
                }

                var cn = disabled ? 'btn-success' : 'btn-default';
                var text = !disabled ? <span><i className="fa fa-check"/> Assign</span> : 'Assigned';
                return (<RestrictedComponent permissionCheck={schema.EVENT_TAB_PLAYER.UPDATE}>
                    <button disabled={disabled}
                        className={'btn ' + cn}
                        onClick={this.props.handlePreferenceAssign}>
                            {text}
                    </button>
                </RestrictedComponent>);
            }
        }

        return (<div>
            {(!isDefault && !this.isPreviewPref()) ? <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_PLAYER_SETTINGS.SET_DEFAULT}>
                <button className="btn btn-default" onClick={this.handleAssignDefault} style={{marginRight: '.5em'}}>
                    <i className="fa fa-check"/> Make Default
                </button>
            </RestrictedComponent> : null}
            <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_PLAYER_SETTINGS.UPDATE}>
                <Link to={"/manage/player/edit?id=" + this.props.preferenceID}>
                    <button className="btn btn-default" style={{marginRight: '.5em'}}>
                        <i className="fa fa-pencil"/> Edit
                    </button>
                </Link>
            </RestrictedComponent>
            <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_PLAYER_SETTINGS.DELETE}>
                <button className="btn btn-danger" onClick={this.toggleDeleteModal}>
                    <i className="fa fa-trash-can"/> Delete
                </button>
            </RestrictedComponent>
        </div>);
    },

    renderDeleteModal: function () {
        if (this.state.deleteModal) {
            return (<Modal
                cancelModal={this.toggleDeleteModal}
                saveAction={<button className="btn btn-danger" onClick={this.handleDelete}>Delete</button>}>
                <Modal.Header>
                    Delete Player Preference
                </Modal.Header>
                <Modal.Body>
                    <div className="alert alert-danger">
                        <h5>This cannot be undone!</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>);
        }
    },

    renderPreviewAssignModal: function () {
        if (!this.state.previewAssignModal) return null;
        return (<Modal
            cancelModal={this.togglePreviewAssignModal}
            saveAction={<button className="btn btn-danger" onClick={this.handlePreviewAssignConfirm}>Assign Anyway</button>}>
            <Modal.Header>
                Assign Preview Preference?
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-danger">
                    <h5 style={{marginTop: 0}}>This will affect anyone watching this event.</h5>
                    <p>
                        This preference uses a preview format. The currently
                        deployed player cannot render it and assigning will cause
                        the player to crash for anyone watching the archive
                        recording of this event.
                    </p>
                    <p>
                        Only proceed if you have confirmed nobody is actively
                        viewing this event. To preview without assigning, copy
                        this event's player URL from the Share field above and
                        append <code>&amp;id={this.props.preferenceID}</code>.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>);
    }
});

export default Preference;
